import http from "../http-common";
import authHeader from './auth-header';

const API_URL = 'images';

class ImageService {
    getAll(type, source, builder, manuals, city, state, country, locationType, locationSubtype, isPanoramic, isHeader, isHomepage, sort, limit, skip) {
        return http.get(API_URL, { 
            params: { 
                type: type, 
                source: source ? source.trim() : null, 
                builder: builder ? builder.trim() : null, 
                manuals: manuals ? manuals.trim() : null, 
                city: city ? city.trim() : null, 
                state: state ? state.trim() : null, 
                country: country ? country.trim() : null, 
                locationType: locationType, 
                locationSubtype: locationSubtype, 
                isPanoramic: isPanoramic, 
                isHeader: isHeader, 
                isHomepage: isHomepage, 
                sort: sort, 
                limit: limit, 
                skip: skip 
            }, 
            headers: authHeader() 
        });
    }

    getAllPending() {
        return http.get(API_URL, { params: { pending: 1 }, headers: authHeader() });
    }

    get(id) {
        return http.get(API_URL + `/${id}`, { headers: authHeader() });
    }

    create(file, data) {
        let formData = new FormData();

        const json = JSON.stringify(data);
        const blob = new Blob([json], { type: 'application/json' });
        formData.append("document", blob);

        formData.append("imageFile", file);

        let headers = authHeader();
        headers['Content-Type'] = 'multipart/form-data';

        return http.post(API_URL, formData, { headers: headers });
    }

    update(id, file, data) {
        let formData = new FormData();

        const json = JSON.stringify(data);
        const blob = new Blob([json], { type: 'application/json' });
        formData.append("document", blob);

        if (file != null) {
            formData.append("imageFile", file);
        }

        let headers = authHeader();
        headers['Content-Type'] = 'multipart/form-data';

        return http.patch(API_URL + `/${id}`, formData, { headers: headers });
    }

    delete(id) {
        return http.delete(API_URL + `/${id}`, { headers: authHeader() });
    }
}

export default new ImageService();